import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'
import { BOLETA_DE_VENTA, FACTURA } from '../../../../common/types/tipoComprobanteType';
import { FORMAT_2DECIMALS } from '../../../../common/types/regularExpresionType';

import global from '../../../../common/utility/global';

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-9"}>
                <Form.Item>
                    <InputGroup compact>
                        {/*              <Form.Item style={{ width: '20%' }}>
                            {
                                props.onGetFieldDecorator('flagExportacion', {
                                    initialValue: props.formValues.flagExportacion,
                                    valuePropName: 'checked'
                                })(<Checkbox>Exportación</Checkbox>)
                            }
                        </Form.Item> */}
                        {
                            props.onGetFieldValue('idTipoComprobante') !== undefined && (props.onGetFieldValue('idTipoComprobante')).key === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagDetraccion', {
                                        initialValue: props.formValues.flagDetraccion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagDetraccion", e.target.checked)}
                                        >
                                            Detracción
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                        {props.onGetFieldValue('flagDetraccion') ?
                            <Form.Item style={{ width: '40%' }}>
                                {props.onGetFieldDecorator('idDetraccion', {
                                    initialValue: props.formValues.idDetraccion ?
                                        { key: props.formValues.idDetraccion } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Detracción"}
                                        optionFilterProp="children"
                                        onChange={(item, element) => props.onChangeTotals("idDetraccion", element.props.data.porcentaje)}
                                    >
                                        {props.formValues.detracciones.map(item => (
                                            <Option
                                                key={item.id}
                                                value={item.id}
                                                data={item}
                                            >{item.codigoSunat + " - " + item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item> : null
                        }
                    </InputGroup>
                </Form.Item>

                <Form.Item>
                    <InputGroup compact>

                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagPercepcion', {
                                        initialValue: props.formValues.flagPercepcion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagPercepcion", e.target.checked)}
                                        >
                                            Percepción
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }

                        {props.onGetFieldValue('flagPercepcion') ?
                            <Form.Item style={{ width: '40%' }}>
                                {props.onGetFieldDecorator('idPercepcion', {
                                    initialValue: props.formValues.idPercepcion ?
                                        { key: props.formValues.idPercepcion } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Percepción"}
                                        optionFilterProp="children"
                                        onChange={(item, element) => props.onChangeTotals("idPercepcion", element.props.data.porcentaje)}
                                    >
                                        {props.formValues.percepciones.map(item => (
                                            <Option
                                                key={item.id}
                                                value={item.id}
                                                data={item}
                                            >{item.codigoSunat + " - " + item.nombre} {item.porcentaje + " %"}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item> : null
                        }


                    </InputGroup>
                </Form.Item>

                <Form.Item>
                    <InputGroup compact>
                        <Form.Item style={{ width: '20%' }}>
                            {props.onGetFieldDecorator('flagDescuentoGlobal', {
                                initialValue: props.formValues.flagDescuentoGlobal,
                                valuePropName: 'checked'
                            })(
                                <Checkbox
                                    onChange={(e) => props.onChangeTotals("flagDescuentoGlobal", e.target.checked)}
                                >
                                    Descuento Global
                                </Checkbox>
                            )}
                        </Form.Item>
                    </InputGroup>
                </Form.Item>

                <Form.Item>
                    <InputGroup compact>
                        <Form.Item style={{ width: '20%' }}>
                            {props.onGetFieldDecorator('flagPrecioIncluyeIGV', {
                                initialValue: props.formValues.flagPrecioIncluyeIGV,
                                valuePropName: 'checked'
                            })(
                                <Checkbox
                                    onChange={(e) => props.onChangeTotals("flagPrecioIncluyeIGV", e.target.checked)}
                                >
                                    {props.onGetFieldValue("flagPrecioIncluyeIGV") ? 'Ingresar Precio U.' : 'Ingresar Valor U.'} {props.formValues.flagPrecioIncluyeIGV}
                                </Checkbox>
                            )}
                        </Form.Item>
                    </InputGroup>
                </Form.Item>

                {
                    props.formValues.idTipoComprobante === FACTURA.ID ?
                        <Form.Item>
                            <InputGroup compact>
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagRetencion', {
                                        initialValue: props.formValues.flagRetencion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagRetencion", e.target.checked)}
                                        >
                                            Retención
                                        </Checkbox>
                                    )}
                                </Form.Item>
                            </InputGroup>
                        </Form.Item> : null
                }
            </div>

            <div className="col-md-3 pt-10">
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label>Porcentaje Percepción</label>
                                <div>{props.onGetFieldValue('porcentajePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Detracción</label>
                                <div>{props.onGetFieldValue('porcentajeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {props.onGetFieldValue("flagDescuentoGlobal") ?
                    (

                        <div className="col text-right mb-5" hidden>
                            <div className="total-inline">

                                <label className='mr-5'>Porcentaje Descuento Global</label>
                                <Form.Item>
                                    {props.onGetFieldDecorator('porcentajeDescuentoGlobal', {
                                        initialValue: parseFloat(props.formValues.porcentajeDescuentoGlobal).toFixed(2),
                                        rules: [{
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato decimal incorrecto (0.00)"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            placeholder="Ingresar porcentaje de descuento global"
                                            autoComplete="off"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                props.onSetFieldsValue({
                                                    porcentajeDescuentoGlobal: global.onBlurDecimals(e, 2)
                                                });
                                                props.onChangeTotals("porcentajeDescuentoGlobal", e.target.value);


                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                    )
                    : null
                }
                {props.onGetFieldValue("flagDescuentoGlobal") ?
                    (
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label className='mr-5'>Importe Descuento Global</label>
                                <Form.Item>
                                    {props.onGetFieldDecorator('importeDescuentoGlobal', {
                                        initialValue: parseFloat(props.onGetFieldValue("importeDescuentoGlobal")).toFixed(2)
                                    })(
                                        <Input
                                            className="text-right"
                                            placeholder="Ingresar importe de descuento global"
                                            autoComplete="off"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                props.onSetFieldsValue({
                                                    importeDescuentoGlobal: global.onBlurDecimals(e, 2)
                                                });
                                                props.onChangeTotals("importeDescuentoGlobal", e.target.value);


                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                    )
                    : null
                }


                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.onGetFieldValue('sumaTotalDetalle').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.formValues.totalDetalleExonerado > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Exonerada</label>
                                <div>{props.formValues.totalDetalleExonerado.toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.totalDetalleInafecto > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Inafecta</label>
                                <div>{props.formValues.totalDetalleInafecto.toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2) === "-0.00" ? "0.00" : props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>

                {
                    props.formValues.totalDetalleGratuito > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Gratuita</label>
                                <div>{props.formValues.totalDetalleGratuito.toFixed(2)}</div>
                            </div>
                        </div> : null
                }



                {/*                 <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>ISC</label>
                        <div>{props.onGetFieldValue('sumaIsc').toFixed(2)}</div>
                    </div>
                </div> */}
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Percepción</label>
                                <div>{props.onGetFieldValue('importePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Percepción</label>
                                <div>{props.onGetFieldValue('totalPercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Detracción</label>
                                <div>{props.onGetFieldValue('importeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Detracción</label>
                                <div>{props.onGetFieldValue('totalDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagRetencion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Retención</label>
                                <div>{props.onGetFieldValue('porcentajeRetencion').toFixed(2)}%</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagRetencion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Retención</label>
                                <div>{props.onGetFieldValue('importeRetencion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
            </div>
        </div>
    );
}